import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { DrawApiModel } from '@models/api-models/draws-params.model';
import { ApiRouterService } from '@shared/services/api-router.service';
import { BehaviorSubject, Observable } from 'rxjs';
import { AuthenticationService } from '../authentication.service';
import { shareReplay } from 'rxjs/operators';

/**
 * Draw API service. Provides the app with draws data from the API.
 */
@Injectable({
	providedIn: 'root'
})
export class DrawAPIService extends ApiRouterService {

	public drawsByType$: Observable<any>

	constructor(

		private http: HttpClient,
		private authService: AuthenticationService

	) {

		super();

	}

	/**
	 * Gets the draws order by date from API.
	 * @param draw Uses the draw for obtain the date and limit of the draw.
	 * @returns The callback from the API
	 */
	public getDrawsByDate(draw: DrawApiModel): Observable<any> {

		this.httpHeaders = new HttpHeaders({
			'Content-Type': 'application/json',
		});
		const httpOptions = { headers: this.httpHeaders };
		return this.http.get(`${this.URL}miloto/sorteos?sort=fecha&fecha=>=${draw.date}&limit=${draw.limit}&activos=1`, httpOptions);

	}

	/**
	 * Gets the draw from the API sorted by type
	 * @returns The callback from the API
	 */
	public getDrawsByType(): void {

		this.httpHeaders = new HttpHeaders({
			'Content-Type': 'application/json',
		});
		const httpOptions = { headers: this.httpHeaders };
		this.drawsByType$ = this.http.get(`${this.URL}miloto/sorteos/ultimos-sorteos-por-tipo`, httpOptions).pipe(shareReplay());
		return;
	}

	public getDrawsByGame(): Observable<any> {
		const token = this.authService.loadToken();

		this.httpHeaders = new HttpHeaders({
			'Content-Type': 'application/json',
			token
		});
		const httpOptions = { headers: this.httpHeaders };
		return this.http.get(`${this.URL}sorteos/juegos`, httpOptions).pipe(shareReplay());
	}

	private _drawsSubject: BehaviorSubject<any> = new BehaviorSubject<any>(null);
	public draws$: Observable<any> = this._drawsSubject.asObservable();

	public getUpcomingDraws(): Observable<any> {

		this.httpHeaders = new HttpHeaders({
			'Content-Type': 'application/json',
		});
		const httpOptions = { headers: this.httpHeaders };
		return this.http.get(`${this.URL}newSorteos?semanas=2`, httpOptions);
	}

	getCurrentDraws(): any {
		return this._drawsSubject.getValue();
	}

	updateDraws(draws: any): void {
		this._drawsSubject.next(draws);
	}
	
	public getProductosDisponibles(): Observable<any> {
		const token = this.authService.loadToken();

		this.httpHeaders = new HttpHeaders({
			'Content-Type': 'application/json',
			token
		});
		const httpOptions = { headers: this.httpHeaders };
		return this.http.get(`${this.URL}productosPenya/disponibles`, httpOptions);

	}
	/**
	 * Get single draw from the API
	 * @returns The callback from the API
	 */
	public getDrawById(id: number): Observable<any> {
		const token = this.authService.loadToken();

		this.httpHeaders = new HttpHeaders({
			'Content-Type': 'application/json',
			token
		});
		const httpOptions = { headers: this.httpHeaders };

		return this.http.get(`${this.URL}sorteos/${id}`, httpOptions);
	}

	public hasTrends(fecha: string, juegoId: number) {
		const token = this.authService.loadToken();

		this.httpHeaders = new HttpHeaders({
			'Content-Type': 'application/json',
			token
		});
		const httpOptions = { headers: this.httpHeaders };

		return this.http.get(`${this.URL}hasTrends?fecha=${fecha}&juego_id=${juegoId}`, httpOptions);
	}

}
